export const DateFilterIsInTheLast = "is in the last"

export const DateFilters = {
  InTheLast: "is in the last",
  OlderThan: "is older than",
  Between: "is between",
  After: "is after",
  Before: "is before",
  EqualTo: "is equal to",
}

export const FulfilmentFilters = {
  NotFulfilled: "not_fulfilled",
  Fulfilled: "fulfilled",
  PartiallyFulfilled: "partially_fulfilled",
  Returned: "returned",
  PartiallyReturned: "partially_returned",
  Shipped: "shipped",
  PartiallyShipped: "partially_shipped",
  Canceled: "canceled",
  RequiresAction: "requires_action",
}

export const PaymentFilters = {
  Awaiting: "awaiting",
  Captured: "captured",
  Refunded: "refunded",
  NotPaid: "not_paid",
  PartiallyRefunded: "partially_refunded",
  Canceled: "canceled",
  RequiresAction: "requires_action",
}

export const StatusFilters = {
  Pending: "pending",
  Completed: "completed",
  Canceled: "canceled",
  Archived: "archived",
  RequiresAction: "requires_action",
}
